import React from 'react'

import Customers from './Customers'
import Contacts from './Contacts'

const CUSTOMERS_VIEW = 'customersView'
const CONTACTS_VIEW = 'contactsView'

class CustomersContainer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      mode: CUSTOMERS_VIEW,
      customerSelected: {}
    }
  }

  onCustomerSelection = (customerSelected) => {
    this.setState({ customerSelected, mode: CONTACTS_VIEW})
  }

  onBackSelection = () => {
    this.setState({ customerSelected: {}, mode: CUSTOMERS_VIEW})
  }

  render() {
    const { mode, customerSelected } = this.state
    if (mode === CUSTOMERS_VIEW){
      return <Customers onCustomerSelection={this.onCustomerSelection}/>
    } else if (mode === CONTACTS_VIEW){
      return (
        <Contacts 
          customer={customerSelected}
          customerId={customerSelected.id}
          onBackClicked={this.onBackSelection}/>
      )
    }
  }

}

export default CustomersContainer



// WEBPACK FOOTER //
// ./src/customer/CustomersContainer.js